import { render, staticRenderFns } from "./packetRain.vue?vue&type=template&id=2c4bd082&scoped=true&"
import script from "./packetRain.ts?vue&type=script&lang=ts&"
export * from "./packetRain.ts?vue&type=script&lang=ts&"
import style0 from "./packetRain.vue?vue&type=style&index=0&id=2c4bd082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4bd082",
  null
  
)

export default component.exports